export default class HandleSlideUp {
  constructor() {
    this.$elements = Array.from(document.querySelectorAll('.slide-up'))
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          let target = entry.target
          target.classList.add('slide-up-animated')
          observer.unobserve(target);
        }
      })
    });

    this.$elements.forEach($element => {
      observer.observe($element)
    })
  }
}